import React, { useEffect, useRef } from "react"
import types from "prop-types"
import ItemRow from "shared/ItemRow"
import { FormIcon } from "shared/icons"

const FormAccessList = ({ category }) => {
  const solutionRef = useRef()

  useEffect(() => {
    solutionRef.current?.expand()
  }, [])

  return (
    <ItemRow
      ref={solutionRef}
      collapsable
      itemRowHeaderContent={(
        <span>{category.categoryName} Solution</span>
      )}
      itemRowBody={(
        <>
          {
            category.forms.map((form) => (
              <ItemRow
                key={form.id}
                className="dark"
                itemRowHeaderContent={(
                  <>
                    <div className="flex gap-2 items-center">
                      <FormIcon className="w-8 h-8" form={form} />
                      <span>{form.title}</span>
                    </div>
                    <div className="text-sm p-2 bg-white rounded">
                      {form.resolved_access_level}
                    </div>
                  </>
                )}
              />
            ))
          }
        </>
      )}
    />
  )
}

FormAccessList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  category: types.object.isRequired,
}

export default FormAccessList
